import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { Box, Tooltip, Typography } from '@mui/material';
import type React from 'react';

import { PERMISSION_METADATA } from '../../constants/permissionMetadata';
import type { Permission } from '../../shared/constants/permissions';

export interface PermissionTooltipProps {
  permissionKey: Permission;
  isGranted: boolean;
}

export const PermissionTooltip: React.FC<PermissionTooltipProps> = ({
  permissionKey,
  isGranted,
}) => {
  const metadata = PERMISSION_METADATA[permissionKey];

  if (!metadata) {
    return null;
  }

  const { description, action, scope } = metadata;

  // Formatting based on PRD: 'Current state: This user can [action] to [scope]'
  // We omit 'to' because the scope strings already include prepositions (e.g., 'within', 'across').
  const stateText = isGranted
    ? `Current state: This user can ${action} ${scope}`
    : `Current state: This user cannot ${action} ${scope}`;

  const tooltipContent = (
    <Box sx={{ p: 0.5, maxWidth: 300 }}>
      <Typography variant="body2" sx={{ mb: 1 }}>
        {description}
      </Typography>
      <Typography variant="caption" sx={{ fontWeight: 'bold' }}>
        {stateText}
      </Typography>
    </Box>
  );

  return (
    <Tooltip title={tooltipContent} placement="top" arrow>
      <Box component="span" sx={{ display: 'inline-flex', verticalAlign: 'middle', ml: 0.5 }}>
        <InfoOutlinedIcon fontSize="small" color="action" />
      </Box>
    </Tooltip>
  );
};
